import moment from 'moment-timezone'
export default function () {
  return {
    campgrounds: [],
    campsites: [],
    campsiteTypes: [],
    parkingAreas: [],
    searchCriteria: {
      campsiteType: null,
      campground: null,
      accessible: false,
      campfire: false,
      date: moment().format('YYYY-MM-DD'),
      vehicleID: '', // for parking form
      view: 'list', // for campsites
      admin: false,
      showUnavailable: false,
      searching: false
    }
  }
}
